'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _searchSuggestions = require('./remote/searchSuggestions');

var SearchSuggestions = {
    fetchSuggestions: function fetchSuggestions(params) {
        return _searchSuggestions.SearchSuggestionsRemote.fetchSuggestions(params);
    }
};

exports.default = SearchSuggestions;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/searchSuggestions.js
// module id = v7uI
// module chunks = 46